// src/constants.ts
var ACCOUNT_COOKIE_NAME = "currentAccountId";
var SSO_HINT_COOKIE_NAME = "ssohint";
var SESSION_URL = "/api/v4/session/";
var SESSION_COOKIE_STATUS_URL = "/api/bridge/session-cookie-status";
var LOGIN_URL = "/app/login";
var JWT_REFRESH_INTERVAL = 10 * 60 * 1e3;
var ACCOUNT_RECONCILE_TTL = 15 * 60 * 1e3;
var ACCOUNT_RECONCILED_AT_STORAGE_NAME = "currentAccountIdReconciledAt";
var JWT_REFRESH_RETRY_BACKOFF = 2e3;

export {
  ACCOUNT_COOKIE_NAME,
  SSO_HINT_COOKIE_NAME,
  SESSION_URL,
  SESSION_COOKIE_STATUS_URL,
  LOGIN_URL,
  JWT_REFRESH_INTERVAL,
  ACCOUNT_RECONCILE_TTL,
  ACCOUNT_RECONCILED_AT_STORAGE_NAME,
  JWT_REFRESH_RETRY_BACKOFF
};
//# sourceMappingURL=chunk-NIGJJYQN.mjs.map